import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { reduxForm, Field } from 'redux-form';
import { Link } from 'react-router-dom';

import Layout from './layout';
import validators from './shared/validators';
import FormField from './checkout-steps/shared/form-field';
import styles from './styles/pages/signin.scss';
import APP_ROUTES from '../constants/app-routes';

class userSignup extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        document.title = this.props.intl.formatMessage({ id: 'register', defaultMessage: 'Register' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'register', defaultMessage: 'Register' });
        }
    }

    closeModal() {
        this.props.closeModal();
    }

    handleFormSubmit(formData) {
        this.props.submitSignupForm(formData, this.props.locale.currentLocale).then(() => {
        });
    }

    render() {
        const {
            handleSubmit, intl, valid, submitting,
        } = this.props;
        return (
            <Layout>
                <main className={`content ${styles.signin}`}>
                    <div className={`container ${styles.bodyContainer}`}>
                        <section>
                            <p className={styles.titlePage}>
                                <FormattedMessage id="register" defaultMessage="Register" />
                            </p>
                            <div className="row">
                                <div className="col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12">
                                    <form className={styles.form} onSubmit={handleSubmit(this.handleFormSubmit)}>
                                        <div>
                                            <div className={`form-group ${styles.formGroup}`}>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 holder">
                                                    <Field
                                                        className={styles.formInput}
                                                        name="user[email]"
                                                        component={FormField.inputFieldMarkup}
                                                        type="text"
                                                        autoComplete="off"
                                                        validate={[validators.required, validators.email]}
                                                        placeholder={intl.formatMessage({
                                                            id: 'email',
                                                            defaultMessage: 'Email',
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`form-group ${styles.formGroup}`}>
                                                <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.inputGroupEdited}`}>
                                                    <Field
                                                        className={styles.formInput}
                                                        name="user[password]"
                                                        component={FormField.inputFieldMarkup}
                                                        autoComplete="off"
                                                        type="password"
                                                        validate={[validators.required]}
                                                        placeholder={intl.formatMessage({
                                                            id: 'password',
                                                            defaultMessage: 'Password',
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`form-group ${styles.formGroup}`}>
                                                <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.inputGroupEdited}`}>
                                                    <Field
                                                        className={styles.formInput}
                                                        name="user[password_confirmation]"
                                                        component={FormField.inputFieldMarkup}
                                                        autoComplete="off"
                                                        type="password"
                                                        validate={[validators.required, validators.passwordConfirmation]}
                                                        placeholder={intl.formatMessage({
                                                            id: 'confirmPassword',
                                                            defaultMessage: 'Confirm Password',
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            <span hidden={[validators.passwordConfirmation]} className={styles.fieldError}>
                                                <FormattedMessage id="error-password-not-match" defaultMessage="Passwords do not match" />
                                            </span>
                                        </div>
                                        <div className={`form-group ${styles.formGroupHolder}`}>
                                            <button className="form-control btn btn-default" type="submit" disabled={!valid || submitting}>
                                                <span>
                                                    <FormattedMessage id="signup" defaultMessage="Sign Up" />
                                                </span>
                                            </button>
                                        </div>
                                        <div className="form-legend">
                                            <FormattedMessage id="legend-required-field" defaultMessage="* indicates the field is required" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                        <div className={`${styles.forgotLinkContainer}`}>
                            <Link to={APP_ROUTES.signin}>
                                <FormattedMessage id="login-my-account" defaultMessage="Login to my account" />
                            </Link>
                        </div>
                    </div>
                </main>
            </Layout>
        );
    }
}

// eslint-disable-next-line no-class-assign
userSignup = reduxForm({
    form: 'userSignup',
})(userSignup);

export default injectIntl(userSignup);



/** WEBPACK FOOTER **
 ** ./src/components/user-signup.jsx
 **/